import { useMemo } from "react";
import { useAdminProducts } from "@/hooks/useAdminStore";
import { useSiteSettings } from "@/hooks/useSiteSettings";
import OfferCard from "@/components/base/OfferCard";

export default function DailyDealsSection() {
  const { products } = useAdminProducts();
  const { settings } = useSiteSettings();

  const allDeals = useMemo(() => {
    const mappedDeals = products
      .filter((product) => product.showInDailyDeals)
      .map((product) => ({
        id: product.id,
        slug: product.slug,
        image: product.image,
        name: product.name,
        price: product.price,
        originalPrice: product.originalPrice,
        discount: product.discount,
        marketplace: product.marketplace,
        freeShipping: product.freeShipping,
        fulfillment: product.fulfillment,
        officialStoreName: product.officialStoreName,
        affiliateLink: product.affiliateLink,
        isFlash: product.badge === "Oferta Relâmpago",
        category: product.category,
        categorySlug: product.categorySlug,
        subcategory: product.subcategory,
        subcategorySlug: product.subcategorySlug,
      }));

    const flashDeals = mappedDeals.filter((deal) => deal.isFlash);
    const otherDeals = mappedDeals.filter((deal) => !deal.isFlash);
    return [...flashDeals, ...otherDeals];
  }, [products]);

  return (
    <section className="py-10 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6 gap-4">
          <div>
            <div className="flex items-center gap-2 mb-0.5">
              <i className="ri-flashlight-fill text-orange-500 text-xl"></i>
              <h2 className="text-2xl font-black text-gray-900">Ofertas do Dia</h2>
              <span className="bg-red-500 text-white text-xs font-bold px-2 py-0.5 rounded-full animate-pulse">
                AO VIVO
              </span>
            </div>
            {settings.homeDealsDescription.trim() && (
              <p className="text-gray-500 text-sm">{settings.homeDealsDescription}</p>
            )}
          </div>

        </div>

        {allDeals.length === 0 ? (
          <div className="rounded-3xl border border-dashed border-gray-200 bg-white py-16 text-center">
            <div className="w-14 h-14 flex items-center justify-center rounded-full bg-gray-50 border border-gray-100 mx-auto mb-4">
              <i className="ri-fire-line text-2xl text-gray-400"></i>
            </div>
            <p className="text-gray-500 font-semibold">Nenhuma oferta habilitada ainda</p>
            <p className="text-gray-400 text-sm mt-1">Marque produtos no cadastro ou no painel /admin/ofertas para publicar esta seção automaticamente.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 items-start">
            {allDeals.map((deal) => (
              <OfferCard key={deal.id} item={deal} className="w-full" />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}